import React from 'react'

import { isMobile } from '@cred/shared/utils'

import { FOX1_THEME, FOX_THEME, WSJ_THEME } from 'common/constants'
import FooterLinks from 'components/footer-links'
import AdvertisementText from 'components/advertisement-text'

import styles from './wsj.module.scss'
import FoxAboveCta from './components/FoxAboveCta'

const copyOnlyConfig = {
  default: {
    AboveCta: () => {},
    Disclosures: () => {},
  },
  [FOX_THEME]: {
    AboveCta: FoxAboveCta,
  },
  [FOX1_THEME]: {
    AboveCta: FoxAboveCta,
  },
  [WSJ_THEME]: {
    Disclosures: () => (
      <FooterLinks
        showTerms={false}
        linkClassName="neutral500"
        tooltipPlacement={isMobile() ? 'top' : 'right'}
        tooltipContentClassName={styles.tooltipContent}
        tooltipContainerClassName={styles.tooltipContainer}
        containerClassName={styles.disclosuresContainer}
      />
    ),
    AboveCta: () => <AdvertisementText placement="right" />,
  },
}
export default copyOnlyConfig
